export default __webpack_public_path__ + "static/media/logo27.2df972d0.png";